import { Box } from '@chakra-ui/react';
import { useMemo, useRef, useState, useEffect } from 'react';
import uPlot from 'uplot';
import 'uplot/dist/uPlot.min.css';
import UPlotReact from 'uplot-react';
import tooltipsPlugin from '../utils/uplot/tooltipPlugin';

let cursLeft = -10;
let cursTop = -10;

function ElevationChart({ data }) {
    const parentDiv = useRef(null);
    const [size, setSize] = useState([0, 0]);

    const cursor = useRef({
        set: (left, top) => {
            cursLeft = left;
            cursTop = top;
        },
        get: () => ({x:true, y: false, drag: {setScale: false}, left: cursLeft, top: cursTop}),
    });

    useEffect(() => {
        const { width, height } = parentDiv.current.getBoundingClientRect();
        const resizeObserver1 = new ResizeObserver(() => {
            const { width, height } = parentDiv.current.getBoundingClientRect();
            setSize([width, 50]);
        });
        resizeObserver1.observe(parentDiv.current);
        setSize([width, 50]);
    }, []);

    const options = useMemo(
        () => ({
            width: size[0],
            height: 140,
            padding: [10,0,10,0],
            cursor: cursor.current.get(),
            // plugins: [
            //     tooltipsPlugin({
            //         cursorMemo: cursor.current,
            //     }),
            // ],
            series: [
                {
                    label: 'Distance along Line',
                },
                {
                    label: 'Elevation (MSL)',
                    points: { show: false },
                    stroke: '#38a138',
                    fill: '#2fdf3d4f',
                    scale: 'y',
                    width: 2,
                    showTooltip: true,
                },
                {
                    label: 'Elevation (MSL)',
                    points: { show: false },
                    stroke: '#2376c4',
                    fill: '#2f99df4f',
                    scale: 'y',
                    width: 2,
                    showTooltip: true,
                },
                {
                    label: 'MSL 0',
                    points: { show: false },
                    stroke: '#00000042',
                    scale: 'y',
                    width: 1,
                    showTooltip: true,
                },
                {
                    label: 'Bedrock',
                    points: { show: false },
                    fill: '#a0bdae5d',
                    scale: 'y',
                    width: 2,
                    showTooltip: true,
                    fillTo: -99999999
                },
            ],
            axes: [
                {
                    show: false,
                    scale: 'x',
                },
                {
                    show: true,
                    scale: 'y',
                    side: 3,
                    space: 16,
                    ticks: {
                        stroke: 'rgba(0,0,0,0.1)',
                    },
                    grid: {
                        stroke: 'rgba(0,0,0,0.1)',
                    },
                },
            ],
            legend: {
                show: false
            },
            scales: { x: {show: false,time:false}, y: {} },
        }),
        [size]
    );

    return (
        <Box zIndex="0" ref={parentDiv} display="flex" justifyContent="stretch" alignItems="stretch">
            <UPlotReact options={options} data={data || [[], []]} />
        </Box>
    );
}

export default ElevationChart;
